import { AppConstants } from '../constants/AppConstants';

export const FetchLearnerAchievementCards = async ({ userSlug }) => {
  const url = `${process.env.REACT_APP_API_URL}${AppConstants.fetchLearnerAchievements}/${encodeURIComponent(userSlug)}`;
  let tempUrl = 'http://localhost:5000/getLearnerAchievements';

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(
        `HTTP error! status: ${response.status} - ${response.statusText}`
      );
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};
